import { useApi } from "../../../swr/useApi";
import { adminChangeRequestsService } from "../../api_client";
import { DocumentsQueryDtoStatusEnum } from "../../../api";

function useStatusCount(status: DocumentsQueryDtoStatusEnum) {
  return useApi(
    `admin-change-request-stats-${status}`,
    () => adminChangeRequestsService.adminListChangeRequests({ page: 1, pageSize: 1, status }),
  );
}

export function useAdminChangeRequestStats() {
  const pending = useStatusCount(DocumentsQueryDtoStatusEnum.Pending);
  const approved = useStatusCount(DocumentsQueryDtoStatusEnum.Approved);
  const rejected = useStatusCount(DocumentsQueryDtoStatusEnum.Rejected);

  return {
    pending: pending.data?.meta?.totalCount,
    approved: approved.data?.meta?.totalCount,
    rejected: rejected.data?.meta?.totalCount,
  };
}
